import { forwardRef } from 'react';

interface SafePlayerFrameProps {
  src: string;
  title: string;
  onLoad: () => void;
  onError: () => void;
  sandboxPolicy?: 'restricted' | 'trusted-no-ads';
}

const SafePlayerFrame = forwardRef<HTMLIFrameElement, SafePlayerFrameProps>(
  function SafePlayerFrame({
    src,
    title,
    onLoad,
    onError,
    sandboxPolicy = 'restricted',
  }, ref) {
    const sandbox = sandboxPolicy === 'restricted'
      ? 'allow-forms allow-modals allow-presentation allow-same-origin allow-scripts'
      : undefined;

    return (
      <iframe
        ref={ref}
        src={src}
        title={title}
        className="absolute inset-0 h-full w-full border-0"
        allowFullScreen
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        // Restricted remains the default. The trusted-no-ads mode is reserved
        // for CineVault's small provider allowlist: those players refuse every
        // sandbox token, while the surf overlay keeps unneeded clicks outside
        // the third-party document.
        sandbox={sandbox}
        referrerPolicy="no-referrer"
        onLoad={onLoad}
        onError={onError}
      />
    );
  },
);

export default SafePlayerFrame;
